export default {
    message: "Los artículos enumerados a continuación están agotados y se han eliminado de su carrito. Realice selecciones diferentes.",
    buttons: {
        ok: "De acuerdo"
    }
}